export const data = [
  {
    name: "Emission Allowances Trading",
    type: "A",
    quality: 0,
    price: 0,
    total: 0,
  },
  {
    name: "Voluntary Emission Credits Trading",
    type: "B",
    quality: 0,
    price: 0,
    total: 0,
  },
  {
    name: "Sell Emission Offsets to other RE funds",
    type: "C",
    quality: 0,
    price: 0,
    total: 0,
  },
];

export const GlanceData = [
  {
    title: "CO2 Traded- Total",
    value: 0,
    price: 0,
  },
  {
    title: "Emission Allowances Traded",
    value: 0,
    price: 0,
  },
  {
    title: "Voluntary Emission Credit Traded",
    value: 0,
    price: 0,
  },
  {
    title: "Emission Offsets sold",
    value: 0,
    price: 0,
  },
];
